import { notificationApi, notificationMarkedApi, ListEntityResponse } from '..';
import { NotificationDto } from './dto';

export async function findAllNotifications() {
  return notificationApi.get<ListEntityResponse<NotificationDto>>(
    '',
    { page: 1, limit: 200, sort: 'voucherStatus', order: 'asc' },
  );
}

export async function markNotificationAsRead(id: number): Promise<void> {
  return notificationMarkedApi.post(`/mark-as-read/${id}`);
}
